import {feedbackOptions} from "../FeedbackUtils";
import BasicFilterSelect from "../../../../../../../common/BasicFilterSelect";

export default function ConstructiveFeedbackFilterSelect({onChange}) {

    return(
        <BasicFilterSelect
            placeholder={'Select feedback type'}
            options={feedbackOptions}
            onChange={onChange}
        />
    )
}